import * as bootstrap from "bootstrap";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import flatpickr from "flatpickr";
import { Korean } from "flatpickr/dist/l10n/ko";
import "flatpickr/dist/themes/material_blue.css";
import lightbox from "lightbox2/dist/js/lightbox-plus-jquery";
import "lightbox2/dist/css/lightbox.min.css";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("ko");
dayjs.tz.setDefault("Asia/Seoul");

flatpickr.localize(Korean);

window.flatpickr = flatpickr;

window.lightbox = lightbox;

lightbox.option({
  resizeDuration: 200,
  wrapAround: false,
});

window.dayjs = dayjs;
window.bootstrap = bootstrap;
window.tinymce = require("tinymce");
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error(
    "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
  );
}

let apiToken = document.head.querySelector('meta[name="api-token"]');

if (apiToken && apiToken.content.length > 0) {
  window.axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${apiToken.content}`;
}
